import React, {useState,useEffect} from "react";
import { PropTypes } from 'prop-types';
import SelectComponent from "./SelectComponent";
import InputComponent from "./InputComponent";
import { Row, Col } from "antd";
import { LabelWrapper, RowWrapper, FormItemWrapper, EmailWrapper, TitleWrapper, InputWrapper } from "../../Step1Setup/styles";
import { SelectComponentWrap } from "./Tabs/styles";
import { MainWrapper, ErrMargin, EmailTitleWrapperFont } from "../styles";
import {
  setSuccessorValues,
  getZipCode,
  emptyZip,
  jsonTemp,
  validationHandler,
  toggleStepTwoUpdateButton,
  setCityFieldEdit
} from "../../actions";
import { connect } from "react-redux";
import {
  filterDataWithDesc,
  filterDataWithValue
} from "../../Data/FilterDropDownData";
import regexMap from "../../../../../utils/regexMap";
import Zipcode from "../../../../../CommonComponents/Zipcode/Zipcode";
import { MarginSpecific } from "./styles";
import { basicImports } from '../../DefaultPropTypes';
import { AddressInfoDerivedStates } from "../../selectors";

export const handleFocusIn = (props, e, type, successors) => {
  let arr = successors;
  if (arr.length > 0) {
    arr.forEach(val => {
      if (type.toLowerCase().includes("state")) {
        val.address.state = undefined;
      } else if (type.toLowerCase().includes("country")) {
        val.address.country = undefined;
      }
    });
  }
  if (props.isStep2Edit) {
    let tempData = props.tempData.tempJSON;
    if (props.contentKey === 1 || props.contentKey === 2) {
      tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
    } else {
      tempData.legacyOptions[
        props.contentKey - 1
      ].successionPlanGranteeOrg = arr;
    }
    props.jsonTemp({
      tempJSON: tempData
    });
  } else {
    props.setSuccessorValues({
      successorAdvisor: arr,
      key: props.contentKey,
      successorKey: props.successorKey - 1
    });
  }
};

export const handleBlur = (props, e, successors, lineNo) => {
  let arr = successors;
  if (arr.length > 0) {
    arr.forEach(val => {
      if (val.key == props.successorKey) {
        if (lineNo == "1") {
          if (val.address.line1 == "") {
            val.address.line1Error = (
              <ErrMargin>Please enter address</ErrMargin>
            );
          } else {
            val.address.line1Error = null;
          }
        } else if (lineNo === "Zipcode") {
          if (val.address.country === "0" && val.address.zip) {
            if ((val.address.zip.length > 0 && val.address.zip.length < 5) ||
              (val.address.zip.length > 5 && val.address.zip.length < 10) ||
              (val.address.zip.length > 10) ||
              (val.address.zip.length === 10 && val.address.zip.indexOf("-") !== 5)) {
              val.address.zipError = (
                <ErrMargin>The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.</ErrMargin>
              );
                val.address.city = null;
                val.address.state = null;
            } else {
              val.address.zipError = null;
            }
          } else {
            if (val.address.zip && val.address.zip.length > 20) {

              val.address.zipError = (
                <ErrMargin>The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.</ErrMargin>
              );
            }
            else {
              val.address.zipError = null;
            }
          }
          if (val.address.zip == "" || !val.address.zip) {

            val.address.zipError = (
              <ErrMargin>Please enter zip code</ErrMargin>
            );
          }


        } else if (lineNo === "City") {
          if (val.address.city == "" || val.address.city == undefined) {

            val.address.cityError = (
              <ErrMargin>Please enter city</ErrMargin>
            );
          } else if (
            val.address.city.length > 0 &&
            val.address.city.length < 2
          ) {

            val.address.cityError = (
              <ErrMargin>City name is too short</ErrMargin>
            );
          } else {
            val.address.cityError = null;
          }
        } else if (lineNo === "State") {
          if (val.address.state == "" || !val.address.state) {

            val.address.stateError = (
              <ErrMargin>Please enter state</ErrMargin>
            );
          } else if (
            val.address.state.length > 0 &&
            val.address.state.length < 2
          ) {

            val.address.stateError = (
              <ErrMargin>State name is too short</ErrMargin>
            );
          } else {
            val.address.stateError = null;
          }
        } else if (lineNo === "Country") {
          if (val.address.country == "" || val.address.country == undefined) {

            val.address.countryError = (
              <ErrMargin>Please specify country</ErrMargin>
            );
          } else {
            val.address.countryError = null;
          }
        }
      }
    });
  }
  if (props.isStep2Edit) {
    let tempData = props.tempData.tempJSON;
    if (props.contentKey == 1 || props.contentKey == 2) {
      tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
    } else {
      tempData.legacyOptions[
        props.contentKey - 1
      ].successionPlanGranteeOrg = arr;
    }
    props.jsonTemp({
      tempJSON: tempData
    });
  } else {
    props.setSuccessorValues({
      successorAdvisor: arr,
      key: props.contentKey,
      successorKey: props.successorKey - 1
    });
  }
};

export const handleChange = (props, e, successors, lineNo, type) => {
  if (props.stepperUpdateIndex.status) {
    props.toggleStepTwoUpdateButton(true);
  }
  let arr = successors;
  if (arr.length > 0) {
    arr.forEach(val => {
      if (val.key == props.successorKey) {
        if (lineNo == "1") {
          if (e.target.value.length > 0) {
            val.address.line1Error = null;
          }
          val.address.line1 = e.target.value;
        } else if (lineNo == "2") {
          val.address.line2 = e.target.value;
        } else if (lineNo == "3") {
          val.address.line3 = e.target.value;
        } else if (lineNo == "Zipcode") {
          if (val.address.country == "0") {
            let reg = /^([-]|[0-9])*$/;
            let zipcode = e.target.value;
            if (reg.test(zipcode)) {
              if ((zipcode.length > 0 && zipcode.length < 5) ||
                (zipcode.length > 5 && zipcode.length < 10) ||
                (zipcode.length > 10) ||
                (zipcode.length == 10 && zipcode.indexOf("-") != 5)) {
                  val.address.city = null;
                  val.address.state = null;
              }
              val.address.zip = zipcode;
              val.address.zipError = null;
              val.address.zipTitle = e.target.title;
            }
          } else {
            val.address.zip = e.target.value;
          }
        } else if (lineNo === "City") {
          if (e.target.value.length > 0) {
            val.address.cityError = null;
          }
          let reg = regexMap.city;
          if (reg.test(e.target.value)) {
            val.address.city = e.target.value;
          }
        } else if (lineNo === "State") {
          let val2 = "";
          if (type === "input") {
            val2 = e.target.value;
          } else {
            let arr = filterDataWithDesc(e, props.stateDropDown);
            if (arr.length > 0) {
              val2 = arr[0].value;
            } else {
              val2 = e;
            }
          }
          if (val2 == undefined) {
            val.address.stateError = null;
          } else if (val2.length > 1) {
            val.address.stateError = null;
          }

          if (type == "input") {
            let reg = /^[a-zA-Z ]{0,100}$/;
            if (reg.test(val2)) {
              val.address.state = val2;
            }
          } else {
            val.address.state = val2;
          }
        } else {
          let countryVal = filterDataWithDesc(e, props.countryDropDown);
          if (countryVal.length > 0) {
            val.address.state = null;
            val.address.zip = null;
            val.address.city = null;
            val.address.zipError = null;
            val.address.stateError = null;
            val.address.cityError = null;
            val.address.country = countryVal[0].value;
          } else {
            val.address.country = "";
          }

          if (val.address.country.length > 0) {
            val.address.countryError = null;
          }

        }
      }
    });
  }
  if (props.isStep2Edit) {
    let tempData = props.tempData.tempJSON;
    if (props.contentKey == 1 || props.contentKey == 2) {
      tempData.legacyOptions[props.contentKey - 1].successorAdvisor = arr;
    } else {
      tempData.legacyOptions[
        props.contentKey - 1
      ].successionPlanGranteeOrg = arr;
    }
    props.jsonTemp({
      tempJSON: tempData
    });
  } else {
    props.setSuccessorValues({
      successorAdvisor: arr,
      key: props.contentKey,
      successorKey: props.successorKey - 1
    });
  }
};

export const AddressInfo = props => {
  const [zipCodeFieldName, setZipCodeFieldName] = useState("")

  let successors;
  if (props.isStep2Edit) {
    if (props.contentKey == 1 || props.contentKey == 2) {
      successors =
        props.tempData.tempJSON.legacyOptions[props.contentKey - 1]
          .successorAdvisor;
    } else {
      successors =
        props.tempData.tempJSON.legacyOptions[props.contentKey - 1]
          .successionPlanGranteeOrg;
    }
  } else {
    successors =
      props.legacy.legacyOptions[props.contentKey - 1].successorAdvisor
        .successorAdvisor;

  }

  useEffect(() => {
    setZipCodeFieldName(getZipCodeFieldName(props.contentKey,props.successorKey))
  }, [props]);

  const getZipCodeFieldName = (key,index) => {
    switch(key){
      case 1: return `oaa-zipCodeAccordion1${index}`; break;
      case 2: return `oaa-zipCodeAccordion2${index}`; break;
      case 4: return `oaa-zipCodeAccordion4${index}`; break;
    }
  }

  return (
    <MainWrapper>
      <RowWrapper>
        <LabelWrapper>Address</LabelWrapper>
      </RowWrapper>
      <Row>
        <Col lg={{ span: 21 }} md={{ span: 16 }}>
          <InputComponent
            id={`txtAddressLine ${props.successorKey}${props.contentKey}`}
            handleBlur={e => handleBlur(props, e, successors, "1")}
            title="Address line 1"
            placeholder="Enter address line 1"
            data-test="address-line-1"
            handleInputChange={e => handleChange(props, e, successors, "1")}
            value={successors[props.successorKey - 1].address.line1}
            max={50}
          />
          {successors[props.successorKey - 1].address.line1Error
            ? successors[props.successorKey - 1].address.line1Error
            : null}
        </Col>
      </Row>
      <Row>
        <Col lg={{ span: 21 }} md={{ span: 16 }}>
          <InputComponent
            id={`"txtAddressLine2" ${props.successorKey}${props.contentKey}`}
            title="Address line 2 (Optional)"
            placeholder="Enter address line 2"
            data-test="address-line-2"
            handleInputChange={e => handleChange(props, e, successors, "2")}
            value={successors[props.successorKey - 1].address.line2}
            max={50}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={{ span: 21 }} md={{ span: 16 }}>
          <InputComponent
            id={`txtAddressLine3 ${props.successorKey}${props.contentKey}`}
            title="Address line 3 (Optional)"
            placeholder="Enter address line 3"
            data-test="address-line-3"
            handleInputChange={e => handleChange(props, e, successors, "3")}
            value={successors[props.successorKey - 1].address.line3}
            max={50}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
        <SelectComponentWrap>
            <SelectComponent
              handleFocusIn={e => handleFocusIn(props, e, "country", successors)}
              handleBlur={e => handleBlur(props, e, successors, "Country")}
              id={`country${props.successorKey}${props.contentKey}`}
              title="Country"
              data-test="country"
              placeholder="-Select-"
              data={props.countryDropDown}
              showArrow={true}
              handleInputChange={e => {
                handleChange(props, e, successors, "Country")
              }}
              value={
                props.countryDropDown &&
                filterDataWithValue(successors[props.successorKey - 1].address.country,props.countryDropDown).map(val => val.desc)
              }
              disabled={props.zipCodeData[zipCodeFieldName] && props.zipCodeData[zipCodeFieldName].loading}
            />
            {successors[props.successorKey - 1].address.countryError
              ? successors[props.successorKey - 1].address.countryError
              : null}
          </SelectComponentWrap>
        </Col>
        <Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
          <FormItemWrapper
            colon={false}
            label={
                <MarginSpecific paddingTop="2px">
                  <EmailWrapper>
                    <EmailTitleWrapperFont>Zip Code</EmailTitleWrapperFont>
                  </EmailWrapper>
                </MarginSpecific>
            }
          >
            <InputWrapper>
              <Zipcode
                isUS={successors[props.successorKey - 1].address.country === '0'}
                name='zipcode'
                placeholder='Enter Zip Code'
                data-test="zipcode"
                title={zipCodeFieldName}
                maxLength={successors[props.successorKey - 1].address.country == '0' && '20'}
                onBlur={e => handleBlur(props, e, successors, "Zipcode")}
                onChange={e => handleChange(props, e, successors, "Zipcode")}
                value={successors[props.successorKey - 1].address.zip}
                id={"zipCode" + props.successorKey+props.contentKey}
              />
            </InputWrapper>
          </FormItemWrapper>
          {successors[props.successorKey - 1].address.zipError
            ? successors[props.successorKey - 1].address.zipError
            : null}
        </Col>
        </Row>
        <Row>
        <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
          <InputComponent
           id={"txtCity"+props.successorKey+props.contentKey}
            title="City"
            placeholder="Enter city"
            data-test="city"
            handleBlur={e => handleBlur(props, e, successors, "City")}
            handleInputChange={e => {
              handleChange(props, e, successors, "City")
            }}
            value={successors[props.successorKey - 1].address.city}
            max={100}
            disabled={props.zipCodeData[zipCodeFieldName] && props.zipCodeData[zipCodeFieldName].loading}
          />
          {successors[props.successorKey - 1].address.cityError
            ? successors[props.successorKey - 1].address.cityError
            : null}
        </Col>
        {successors[props.successorKey - 1].address.country === "0" ?
          (<Col lg={{ span: 10, offset: 1 }} md={{ span: 10 }}>
            <SelectComponentWrap>
              <SelectComponent
                handleFocusIn={e => handleFocusIn(props, e, "state", successors)}
                handleBlur={e => handleBlur(props, e, successors, "State")}
                id={`state${props.successorKey}${props.contentKey}`}
                title="State"
                data-test="state"
                placeholder="-Select-"
                data={props.stateDropDown}
                showArrow={true}
                handleInputChange={e => {
                  handleChange(props, e, successors, "State")
                }}
                value={
                  successors[props.successorKey - 1].address.state ? 
                  filterDataWithValue(successors[props.successorKey - 1].address.state,props.stateDropDown)[0].desc : undefined
                }
                disabled={props.zipCodeData[zipCodeFieldName] && props.zipCodeData[zipCodeFieldName].loading}
              />
            </SelectComponentWrap>
            {successors[props.successorKey - 1].address.stateError
              ? successors[props.successorKey - 1].address.stateError
              : null}
          </Col>) : null}
      </Row>
    </MainWrapper>
  );
};

const mapStateToProps = (state, ownProps) => ({
  ...AddressInfoDerivedStates(state.toJS()),
	legacy: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions"]),
  city: state.getIn([
    "npaFormReducer",
    `legacyOptions`,
    "legacyOptions",
    "legacyOptions",
    `${ownProps.contentKey}`,
    `successorAdvisor`,
    "successorAdvisor",
    `${ownProps.successorKey}`
  ]),
});

export const mapDispatchToProps = (dispatch, ownProps) => ({
  setSuccessorValues: val => dispatch(setSuccessorValues(val)),
  getZipCode: data =>
    dispatch(
      getZipCode({
        zipCode: data.value,
        path: "legacyOptions",
        index: data.index,
        contentKey: data.contentKey,
        stepnum: data.stepnum
      })
    ),
  emptyZip: data => dispatch(emptyZip(data)),
  jsonTemp: val => dispatch(jsonTemp(val)),
  validationHandler: val => dispatch(validationHandler(val)),
  toggleStepTwoUpdateButton: val => dispatch(toggleStepTwoUpdateButton(val))
});

AddressInfo.propTypes = {
  city: PropTypes.any,
  contentKey: PropTypes.number,
  countryDropDown:  basicImports,
  emptyZip: PropTypes.func,
  getZipCode: PropTypes.func,
  isStep2Edit: PropTypes.func,
  jsonTemp: PropTypes.func,
  legacy: PropTypes.object,
  resetAllZipCode: PropTypes.func,
  resetZipCode: PropTypes.func,
  setSuccessorValues: PropTypes.func,
  shouldEmptyZip: PropTypes.any,
  stateDropDown:  basicImports,
  stepperUpdateIndex: PropTypes.any,
  successorKey: PropTypes.string,
  tempData: PropTypes.any,
  toggleStepTwoUpdateButton: PropTypes.func,
  validationHandler: PropTypes.func,
  zipCodeData: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressInfo);
